module.exports = __webpack_public_path__ + "img/nlk.6731dedb.jpg";